import cookie from 'js-cookie'
import GLOBAL_VARIABLE, { PLATFORM_TYPE } from '../../constants/global-variable.enum'
import { initNppMonitor } from '../utils/npp-monitor-util'

const NEXON_HOMEPAGE = 1

function getMetaByAttr(key) {
  const el = document.querySelector(`meta[type="inface"][platform="krpc"]`)

  if (!el) return
  return el.getAttribute(key)
}

class PlatformKRPC {
  constructor({ npp, memberAccessCode, authLibUrl, __useNppMonitor }) {
    this.type = PLATFORM_TYPE.KRPC
    this.npp = npp
    this.memberAccessCode = getMetaByAttr('member_access_code') || memberAccessCode || NEXON_HOMEPAGE // meta tag 가 최우선
    this.authLibUrl = authLibUrl || 'https://platform.nexon.com/ajax/npf_auth_c.js'

    initNppMonitor({ use: __useNppMonitor, platformType: this.type })
  }

  getAuthorization() {
    console.debug('krpc > getAuthorization > npp', this.npp, typeof this.npp)
    if (this.npp) {
      return `Krpc ${this.npp}`
    }
  }

  getWebTokenBody() {
    return { npp: this.npp }
  }

  getVerifyWebTokenBody() {
    this.updateSession()
    return { npp: this.npp }
  }

  updateSession() {
    const value = cookie && cookie.get('NPP')
    console.debug('krpc > updateSession', value, typeof value, !!value)
    if (value) {
      this.npp = value
    }
  }

  clear() {
    const clearTargets = ['ENC', 'NPP', 'IL', 'IM', 'RDB', 'NXCH', 'NXABP', 'NXMABP']
    clearTargets.forEach((cookieKey) => {
      cookie.remove(cookieKey, { domain: GLOBAL_VARIABLE.WEB_TOKEN_DOMAIN })
      cookie.remove(cookieKey)
    })

    this.npp = null
  }
  
  /**
   * NPP 값을 검증합니다.
   * @returns {Boolean}
   */
  isValidSession() {
    this.updateSession()
    console.debug('krpc > isValidSession', this.npp)

    if (!this.npp) {
      return false
    }
    
    return this.npp.indexOf('NP11') > -1 && this.npp.split(':').length > 3
  }
}

export default PlatformKRPC